import React from 'react';
import clsx from 'clsx'; // Optional, to clean up class merging

export function Card({ children, className = '' }) {
  return (
    <div
      className={clsx(
        'bg-white dark:bg-gray-800 rounded-2xl shadow-md p-4 transition-colors duration-300',
        className
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '', title, subtitle }) {
  return (
    <div className={clsx('border-b border-gray-200 dark:border-gray-700 pb-2 mb-4', className)}>
      {title && (
        <h4 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{title}</h4>
      )}
      {subtitle && (
        <p className="text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>
      )}
      {children}
    </div>
  );
}

export function CardContent({ children, className = '' }) {
  return (
    <div className={clsx('px-1 py-2 text-gray-700 dark:text-gray-200', className)}>
      {children}
    </div>
  );
}

// Added CardFooter component
export function CardFooter({ children, className = '' }) {
  return (
    <div
      className={clsx(
        'border-t border-gray-200 dark:border-gray-700 pt-2 mt-4',
        className
      )}
    >
      {children}
    </div>
  );
}
